import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { ReminderArea } from "./Styles";

export default function ReminderDate({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Recordatorio"
            value={!value ? document.reminderDate.parsed : value}
          />
        </div>
      ) : (
        <ReminderArea>
          <Informative
            readonly={true}
            label="Recordatorio"
            value={!value ? document.reminderDate.parsed : value}
          />
        </ReminderArea>
      )}
    </>
  );
}
